import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { PasswordInput } from "@/components/ui/password-input";
import {
  getPortalToken,
  portalChangePassword,
} from "@/modules/tramites/materialidad/clientPortalApi";
import PortalMaterialidadShell from "./PortalMaterialidadShell";

export default function PortalMaterialidadChangePasswordPage() {
  const navigate = useNavigate();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!getPortalToken()) {
      navigate("/portal-materialidad/login", { replace: true });
    }
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await portalChangePassword(currentPassword, newPassword);
      toast.success("Contraseña actualizada.");
      navigate("/portal-materialidad/empresas", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "No se pudo cambiar la contraseña.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <PortalMaterialidadShell>
      <div className="space-y-4" data-testid="portal-materialidad-change-password">
        <h1 className="text-2xl font-semibold text-[#0F2D5C]">Cambiar contraseña</h1>
        <p className="text-sm text-slate-600">
          Por seguridad debe definir una contraseña propia antes de continuar.
        </p>
        <form onSubmit={onSubmit} className="space-y-4 rounded-sm border border-slate-200 bg-white p-5">
          <div>
            <Label>Contraseña actual (temporal)</Label>
            <PasswordInput
              className="rounded-sm"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
            />
          </div>
          <div>
            <Label>Nueva contraseña (mín. 8)</Label>
            <PasswordInput
              className="rounded-sm"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </div>
          <Button type="submit" className="rounded-sm" disabled={busy || newPassword.length < 8}>
            {busy ? <Loader2 className="w-4 h-4 animate-spin mr-2" /> : null}
            Guardar
          </Button>
        </form>
      </div>
    </PortalMaterialidadShell>
  );
}
